<div class="flex items-center justify-center" [className]="customClasses">
    <img class="w-full" src="assets/images/logo/visiolens_logo.png" />
</div>
